import { ams } from './ams';
import { bergamos } from './bergamos';
import { demo } from './demo';
import { dhi } from './dhi';
import { hrimn } from './hrimn';
import { kvcm } from './kvcm';
import { sbl } from './sbl';

// TODO: need to create interface instead of any when we finish config file
// eslint-disable-next-line
const clients: { [key: string]: any } = {
  ams,
  bergamos,
  demo,
  dhi,
  hrimn,
  sbl,
  kvcm
};

const DEFAULT_CLIENT = 'bergamos';

const config = clients[process.env.CLIENT_NAME || DEFAULT_CLIENT];

export default config;
